import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { PricebookDiscountTier } from '../../../admin/components/tools/PricingWizard/types';

export const PRICEBOOK_DISCOUNT_TIERS_QUERY_KEY = 'pricebook/discountTiers';

export function usePricebookDiscountTiersQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_DISCOUNT_TIERS_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookDiscountTier[]>(
				'admin/BillingUtilities/GetPricebookDiscountTiers',
				'GET'
			),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
